import { useState } from "react";
import { Plus } from "lucide-react";
import TrackRow from "@/components/recstudio/TrackRow";
import { channelOf } from "@/components/recstudio/sessionEngine";
import { TRACK_KINDS } from "@/lib/recStudioApi";
import { NO_FX, presetByKey } from "@/lib/vocalPresets";

const MAX_TRACKS = 16;
const PRESET_FOR = { choir: "choir", speech: "preaching" };

function newTrack(kind, tracks) {
  const label = TRACK_KINDS.find((k) => k.key === kind)?.label || "Vocal";
  const same = tracks.filter((t) => t.kind === kind).length;
  const p = presetByKey(PRESET_FOR[kind]);
  return { id: crypto.randomUUID(), name: same ? `${label} ${same + 1}` : label, kind, volume: 80, muted: false, solo: false,
    preset: p?.key || null, fx: JSON.parse(JSON.stringify(p?.fx || NO_FX)), takes: [], active_take_id: null };
}

/** Vocal tracks of the session (pick one to record onto) + add a lead, harmony, ad-lib, choir or spoken track. */
export default function TrackList({ session, selectedId, onSelect, duration }) {
  const { doc, engine, change, updateTrack, removeTrack } = session;
  const [kind, setKind] = useState("harmony");
  const add = () => {
    const t = newTrack(kind, doc.tracks);
    change((d) => ({ ...d, tracks: [...d.tracks, t] }));
    onSelect(t.id);
  };
  const bufOf = (id) => { const i = channelOf(engine, doc.id, id); return i != null ? engine.channels[i].buffer : null; };
  return (
    <section data-testid="rec-track-list" className="space-y-2">
      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/45">Vocal tracks · tap one to record onto it</p>
      {doc.tracks.map((t) => (
        <TrackRow key={t.id} track={t} selected={t.id === selectedId} buffer={bufOf(t.id)} duration={duration} onSelect={() => onSelect(t.id)}
          onChange={(p) => updateTrack(t.id, p)} onPickTake={(id) => updateTrack(t.id, { active_take_id: id }, { reload: true })} onRemove={() => removeTrack(t.id)} />
      ))}
      {doc.tracks.length < MAX_TRACKS ? (
        <div className="flex gap-1.5">
          <select data-testid="rec-add-track-kind" value={kind} onChange={(e) => setKind(e.target.value)} className="min-w-0 flex-1 rounded-xl border border-white/10 bg-black/40 px-2 py-2 text-[12px] text-white focus:outline-none">
            {TRACK_KINDS.map((k) => <option key={k.key} value={k.key}>{k.label}</option>)}
          </select>
          <button type="button" data-testid="rec-add-track" onClick={add} className="inline-flex items-center gap-1.5 rounded-xl border border-rose-300/40 bg-rose-500/10 px-3 py-2 text-[12px] font-semibold text-rose-50 transition-colors duration-150 hover:bg-rose-500/20">
            <Plus className="h-3.5 w-3.5" /> Add track
          </button>
        </div>
      ) : null}
    </section>
  );
}
